// Redux Store配置
import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import settingsReducer from './settingsSlice';
import timersReducer from './timersSlice';

// 配置Redux Store
export const store = configureStore({
  reducer: {
    settings: settingsReducer,
    timers: timersReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// 导出类型
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;